<template>
  <div>
    <header-component />
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="flex justify-between items-center p-2">
          <div>
            <h3
              class="mb-0 w-full font-bold text-gray-800 text-md"
              style="text-transform: capitalize"
            >
              Sales List
            </h3>
          </div>
          <div class="flex items-center">
            <div class="table-filters">
              <el-tag
                v-for="(tag, index) in filters"
                :key="index"
                :disable-transitions="false"
                closable
                @close="removeFilter(index)"
              >
                <span v-if="tag">
                  {{ tag.field }}:
                  <span style="font-weight: bold">
                    {{ tag.label }}
                    <span />
                  </span>
                </span>
              </el-tag>
            </div>
            <el-popover
              v-model="filterPopUpVisible"
              placement="left"
              width="550"
            >
              <table-filter @apply="applyFilters" />
              <base-button
                slot="reference"
                size="sm"
                type="primary"
                style="float: roght-top"
                >Add Filter</base-button
              >
            </el-popover>
          </div>
        </div>

        <!-- Custom Tailwind CSS Table -->
        <div class="overflow-x-auto">
          <table
            class="min-w-full bg-white border border-gray-200"
            style="table-layout: fixed;"
          >
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="px-2 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Branch
                </th>
                <th
                  class="px-2 py-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                  style="width: 100px;"
                >
                  Customer
                </th>
                <th
                  class="px-2 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Date
                </th>
                <th
                  class="px-2 py-2 w-24 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Invoice No.
                </th>
                <th
                  class="px-2 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  SR. No.
                </th>
                <th
                  class="px-2 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Total
                </th>
                <th
                  class="px-2 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Disc
                </th>
                <th
                  class="px-2 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Paid
                </th>
                <th
                  class="px-2 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Payment
                </th>
                <th
                  class="px-2 py-2 w-20 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Created By
                </th>
                <th
                  class="px-2 py-2 w-16 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-b"
                >
                  Actions
                </th>
              </tr>
              <!-- Search Row -->
              <tr class="bg-gray-100">
                <th class="px-2 py-2 border-b">
                  <select
                    v-model="columnFilters.branch"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All Branches</option>
                    <option
                      v-for="branch in branches"
                      :key="branch.id"
                      :value="branch.id"
                    >
                      {{ branch.name }}
                    </option>
                  </select>
                </th>
                <th class="px-2 py-2 border-b">
                  <div class="space-y-1">
                    <input
                      v-model="columnFilters.customerName"
                      type="text"
                      placeholder="Search by name..."
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @input="onColumnFilterChange"
                    />
                    <input
                      v-model="columnFilters.customerPhone"
                      type="text"
                      placeholder="Search by phone..."
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @input="onColumnFilterChange"
                    />
                  </div>
                </th>
                <th class="px-2 py-2 border-b">
                  <input
                    v-model="columnFilters.date"
                    type="date"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-2 py-2 border-b">
                  <input
                    v-model="columnFilters.invoiceNumber"
                    type="text"
                    placeholder="Search invoice..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-2 py-2 border-b">
                  <input
                    v-model="columnFilters.serviceRequestNumber"
                    type="text"
                    placeholder="Search SR..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-2 py-2 border-b">
                  <input
                    v-model="columnFilters.total"
                    type="number"
                    placeholder="Min amount..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-2 py-2 border-b">
                  <select
                    v-model="columnFilters.discountType"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </th>
                <th class="px-2 py-2 border-b">
                  <input
                    v-model="columnFilters.amountPaid"
                    type="number"
                    placeholder="Min paid..."
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @input="onColumnFilterChange"
                  />
                </th>
                <th class="px-2 py-2 border-b">
                  <select
                    v-model="columnFilters.paymentStatus"
                    class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    @change="onColumnFilterChange"
                  >
                    <option value="">All</option>
                    <option value="paid">Paid</option>
                    <option value="pending">Pending</option>
                  </select>
                </th>
                <th class="px-2 py-2 border-b"></th>
                <th class="px-2 py-2 border-b">
                  <!-- Clear filters button -->
                  <button
                    @click="clearColumnFilters"
                    class="px-2 py-1 w-full text-xs text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-1 focus:ring-red-500"
                  >
                    Clear
                  </button>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <!-- Data Rows -->
              <tr
                v-for="sale in tableData"
                :key="sale.saleId"
                class="hover:bg-gray-50"
              >
                <td class="px-2 py-2 text-xs whitespace-nowrap border-b">
                  <span
                    v-if="sale.branchName"
                    class="inline-flex px-1 py-0.5 text-xs font-semibold rounded-full"
                    :style="branchBadgeStyle(sale.branchColor)"
                  >
                    {{ sale.branchName }}
                  </span>
                </td>
                <td class="px-2 py-2 text-xs text-gray-900 border-b">
                  <div
                    class="w-full truncate"
                    :title="sale.user.firstName + ' ' + sale.user.lastName"
                  >
                    {{ sale.user.firstName + " " + sale.user.lastName }}
                  </div>
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ formatDate(sale.date) }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ sale.invoiceNumber }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ sale.serviceRequestNumber || "-" }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ formatCurrency(sale.total) }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  <span v-if="sale.isPercentage === true">
                    {{ sale.discount }}%
                  </span>
                  <span v-else> ₹{{ sale.discount }} </span>
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ formatCurrency(sale.amountPaid) }}
                </td>
                <td class="px-2 py-2 text-xs whitespace-nowrap border-b">
                  <div class="flex flex-col gap-0.5">
                    <span
                      v-if="sale.total > sale.amountPaid"
                      class="inline-flex px-1 py-0.5 text-xs font-semibold text-yellow-800 bg-yellow-100 rounded-full"
                    >
                      Pending
                    </span>
                    <span
                      v-else
                      class="inline-flex px-2 py-0.5 text-xs font-semibold text-green-800 bg-green-100 rounded-full"
                    >
                      Paid
                    </span>
                    <span
                      v-if="returnedSaleIds[sale.saleId]"
                      class="inline-flex px-1 py-0.5 text-xs font-semibold text-red-800 bg-red-100 rounded-full"
                    >
                      Returned
                    </span>
                  </div>
                </td>
                <td class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b">
                  {{ sale.creatorFirstName }} {{ sale.creatorLastName }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  <div class="inline-block relative text-left">
                    <button
                      @click="toggleDropdown(sale.saleId)"
                      class="inline-flex justify-center items-center w-8 h-8 text-gray-600 rounded-full hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                        />
                      </svg>
                    </button>

                    <!-- Dropdown Menu -->
                    <div
                      v-if="activeDropdown === sale.saleId"
                      class="absolute right-0 z-10 mt-1 w-40 bg-white rounded-md border border-gray-200 ring-1 ring-black ring-opacity-5 shadow-lg origin-top-right"
                    >
                      <div class="py-1">
                        <button
                          @click="handleAction(sale, 'creditNotes')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Add Credit Notes
                        </button>
                        <button
                          @click="handleAction(sale, 'saleTransactions')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Show Sale Transactions
                        </button>
                        <button
                          @click="handleAction(sale, 'editSale')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Edit Sale
                        </button>
                        <button
                          @click="handleAction(sale, 'showDetails')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          Print Receipt
                        </button>
                        <button
                          @click="handleAction(sale, 'whatsappPrint')"
                          class="block px-3 py-2 w-full text-xs text-left text-gray-700 hover:bg-gray-100"
                        >
                          WhatsApp Bill Print
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Summary Row -->
              <tr v-if="meta" class="font-semibold bg-gray-50">
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  Total
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ formatCurrency(meta.grandTotal) }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  {{ formatCurrency(meta.paidTotal) }}
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                ></td>
                <td
                  class="px-2 py-2 text-xs text-gray-900 whitespace-nowrap border-b"
                >
                  N/A
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-footer">
          <div
            v-if="meta"
            slot="footer"
            class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
          >
            <div class>
              <p class="card-category">
                Showing {{ meta.from + 1 }} to {{ meta.to }} of
                {{ meta.total }} entries
                <span v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span
                >
              </p>
            </div>
            <pagination :meta="meta" @paginate="setPagination" />
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="showBill" width="60%" title="Bill">
        <show-bill />
      </el-dialog>
      <el-dialog :visible.sync="showTransaction" title="Show Transaction">
        <show-transaction @close="showTransaction = false" />
      </el-dialog>
      <el-dialog
        @open="onDialogOpen"
        @close="onDialogClose"
        :visible.sync="showWhatsappPrintModal"
        width="60%"
        title="Bill"
      >
        <whatsapp-bill-print ref="saleInvoice" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button,
  Tag
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { format } from "date-fns";
import showBill from "./ShowBill";
import ShowTransaction from "./ShowTransaction";
import headerComponent from "../Components/HeaderComponent";
import pagination from "@/components/AmsaPagination";
import tableFilter from "@/components/TableFilterComponent";
import TableFilter from "../../components/SaleTableFilter";
import WhatsAppBillPrint from "./WhatsAppBillPrint.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "../../utils/constants";
export default {
  filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    },
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  components: {
    pagination,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Tag.name]: Tag,
    "show-bill": showBill,
    "show-transaction": ShowTransaction,
    "header-component": headerComponent,
    "table-filter-component": tableFilter,
    "table-filter": TableFilter,
    "whatsapp-bill-print": WhatsAppBillPrint
  },
  data: () => {
    return {
      showBill: false,
      showTransaction: false,
      selectedRows: [],
      pageSize: 10,
      filters: [],
      visibleFilters: [],
      branches: [],
      filterPopUpVisible: false,
      showWhatsappPrintModal: false,
      activeDropdown: null, // Track which dropdown is open
      columnFilters: {
        branch: "",
        customerName: "",
        customerPhone: "",
        date: "",
        invoiceNumber: "",
        serviceRequestNumber: "",
        total: "",
        discountType: "",
        amountPaid: "",
        paymentStatus: ""
      },
      filterTimeout: null,
      returnedSaleIds: {}
    };
  },
  computed: {
    ...mapGetters({
      saleList: "sale/getSaleList",
      sale: "sale/getSale"
    }),
    tableData() {
      return this.saleList.rows;
    },
    meta() {
      return this.saleList.meta;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function(value) {
        this.restructureFilters(value);
      }
    }
  },

  mounted() {
    this.getBranches();
    this.paginate();
    this.fetchReturnedSaleIds();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove click outside listener
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    fetchReturnedSaleIds() {
      apiHelper
        .call("get", endpoints.LARAVEL_BASE_URL + "/api/v1/credit-notes/returned-sale-ids")
        .then(res => {
          const map = {};
          (res.data.sale_ids || []).forEach(id => { map[id] = true; });
          this.returnedSaleIds = map;
        })
        .catch(() => {});
    },
    branchBadgeStyle(color) {
      if (!color) return { background: '#dbeafe', color: '#1e40af' };
      return { background: color, color: '#fff' };
    },
    ...mapActions({
      getSales: "sale/getSales",
      editSale: "sale/editSale",
      getReceipt: "sale/getReceipt",
      getReceiptDataForWhatsapp: "sale/getReceiptDataForWhatsapp",
      getSaleTransactions: "sale/getSaleTransactions"
    }),

    ...mapMutations({
      setSale: "sale/setSale",
      setSaleUser: "sale/setSaleUser"
    }),

    handleAction(sale, command) {
      if (command === "creditNotes") {
        sale.user.id = sale.userId;
        this.setSaleUser(sale.user);
        this.$router.push("/pos/" + sale.saleId + "/credit-notes/");
      } else if (command === "showDetails") {
        this.getReceipt(sale.saleId).then(status => {
          // if (status === 200) {
          //   this.showBill = true;
          // }
        });
      } else if (command === "saleTransactions") {
        this.setSale(sale);
        this.getSaleTransactions(sale.saleId);
        this.showTransaction = true;
      } else if (command === "editSale") {
        const isFullyPaid = sale.amountPaid > 0 && sale.total > 0 && sale.amountPaid >= sale.total;
        if (isFullyPaid) {
          this.$notify({
            message: "This sale is fully paid and cannot be edited. Use \"Add Credit Notes\" to process a return.",
            type: "warning",
            title: "Cannot Edit"
          });
        } else {
          this.editSale(sale.saleId).then(status => {
            if (status === 200) {
              this.$router.push(`/pos/${sale.saleId}/`);
            }
          });
        }
      } else if (command === "whatsappPrint") {
        this.getReceiptDataForWhatsapp(sale.saleId).then(status => {
          if (status === 200) {
            this.showWhatsappPrintModal = true;
          }
        });
      }
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      // this.paginate(data.page, this.filters);
      this.restructureFilters(this.filters, data.page);
    },
    paginate(page = 1, filters = {}) {
      let query = {
        page,
        perPage: this.pageSize,
        ...filters
      };
      this.getSales(query);
    },
    applyFilters(filters) {
      this.filters.push(filters);
      this.filterPopUpVisible = false;
    },
    removeFilter(tagIndex) {
      this.filters.splice(tagIndex, 1);
    },

    restructureFilters(value, page = 1) {
      const filtered = {};
      value.forEach(i => {
        if (i.field === "date") {
          filtered.fromDate = i.value[0];
          filtered.toDate = i.value[1];
        } else {
          filtered[i.field] = i.value;
        }
      });
      if (Object.entries(filtered).length > 0) {
        this.paginate(page, filtered);
      } else {
        this.paginate(page);
      }
    },
    getBranches() {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}/api/v1/branches`)
        .then(res => {
          this.branches = res.data.data;
        })
        .catch(() => {
          this.$notify({
            message: "Something Went Wrong!",
            type: "danger",
            title: "error"
          });
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.meta) {
        columns.forEach((column, index) => {
          switch (index) {
            case 0:
              sums[index] = "Total";
              return;
              break;
            case 5:
              const totalAmount = parseFloat(this.meta.grandTotal) || 0;
              const formattedTotal = new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR"
              }).format(totalAmount);
              sums[index] = formattedTotal.replace(".00", "");

              return;
              break;
            case 7:
              const paidAmount = parseFloat(this.meta.paidTotal) || 0;
              const formattedPaidTotal = new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR"
              }).format(paidAmount);
              sums[index] = formattedPaidTotal.replace(".00", "");

              return;
              break;

            default:
              sums[index] = "N/A";
              break;
          }
        });
      }

      return sums;
    },
    onDialogClose() {
      if (this.$refs && this.$refs.saleInvoice) {
        this.$refs.saleInvoice.resetProperty();
      }
    },
    onDialogOpen() {
      if (this.$refs && this.$refs.saleInvoice) {
        this.$refs.saleInvoice.fetchData(); // Call the fetch function in the child
      }
    },
    formatDate(date) {
      return format(date, "YYYY-MM-DD");
    },
    formatCurrency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    },
    toggleDropdown(saleId) {
      this.activeDropdown = this.activeDropdown === saleId ? null : saleId;
    },
    handleClickOutside(event) {
      // Close dropdown if clicking outside
      if (!event.target.closest(".relative")) {
        this.activeDropdown = null;
      }
    },

    onColumnFilterChange() {
      // Debounce the filter to avoid too many API calls
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.applyColumnFilters();
      }, 300);
    },

    applyColumnFilters() {
      const filters = [];

      // Convert column filters to API filter format
      if (this.columnFilters.branch) {
        filters.push({
          field: "branch",
          label: this.columnFilters.branch,
          value: this.columnFilters.branch
        });
      }

      if (this.columnFilters.customerName) {
        filters.push({
          field: "customerName",
          label: `Name: ${this.columnFilters.customerName}`,
          value: this.columnFilters.customerName
        });
      }

      if (this.columnFilters.customerPhone) {
        filters.push({
          field: "customerPhone",
          label: `Phone: ${this.columnFilters.customerPhone}`,
          value: this.columnFilters.customerPhone
        });
      }

      if (this.columnFilters.date) {
        filters.push({
          field: "date",
          label: this.columnFilters.date,
          value: this.columnFilters.date
        });
      }

      if (this.columnFilters.invoiceNumber) {
        filters.push({
          field: "invoiceNumber",
          label: this.columnFilters.invoiceNumber,
          value: this.columnFilters.invoiceNumber
        });
      }

      if (this.columnFilters.serviceRequestNumber) {
        filters.push({
          field: "serviceRequestNumber",
          label: this.columnFilters.serviceRequestNumber,
          value: this.columnFilters.serviceRequestNumber
        });
      }

      if (this.columnFilters.total) {
        filters.push({
          field: "total",
          label: `Min: ${this.columnFilters.total}`,
          value: this.columnFilters.total
        });
      }

      if (this.columnFilters.discountType) {
        filters.push({
          field: "discountType",
          label: this.columnFilters.discountType,
          value: this.columnFilters.discountType
        });
      }

      if (this.columnFilters.amountPaid) {
        filters.push({
          field: "amountPaid",
          label: `Min: ${this.columnFilters.amountPaid}`,
          value: this.columnFilters.amountPaid
        });
      }

      if (this.columnFilters.paymentStatus) {
        filters.push({
          field: "paymentStatus",
          label: this.columnFilters.paymentStatus,
          value: this.columnFilters.paymentStatus
        });
      }

      // Replace existing filters with column filters
      this.filters = filters;
      this.restructureFilters(filters, 1);
    },

    clearColumnFilters() {
      this.columnFilters = {
        branch: "",
        customerName: "",
        customerPhone: "",
        date: "",
        invoiceNumber: "",
        serviceRequestNumber: "",
        total: "",
        discountType: "",
        amountPaid: "",
        paymentStatus: ""
      };
      this.filters = [];
      this.paginate(1);
    }
  }
};
</script>

<style lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.sales-table {
  .el-table__row {
    text-transform: capitalize;
  }
}
.no-border-card .card-footer {
  border-top: 0;
}
.table-filters {
  display: inline-block;
}
.table-filters .el-tag {
  margin-left: 10px;
}
.el-select-dropdown.el-popper .el-select-dropdown__item.selected {
  color: #5e72e4;
}
.el-select-dropdown.el-popper .el-select-dropdown__item.selected:hover {
  color: white;
}
.baner-branch {
  background-color: #d2f5f1;
  border-color: #c4e4e1;
  color: #60c8be;
}
</style>
